import {locationChange} from '~/components/AnalyticsProvider';
import {Art} from './ArtEvents';
import {Lab} from './LabEvents';

/**
 * Triggered from '~/router/LOCATION_CHANGE' redux action
 */
const PageViewEvents = {
  [locationChange.toString()]: (state, action) => {
    const {pathname} = action.payload;
    if (!pathname) return null;

    switch (true) {
      case pathname.startsWith('/addArt/'):
        return Art.browse(state, action);
      case pathname.startsWith('/next/confirmIntl'):
        return Lab.quoteZip(state, {
          ...action,
          meta: {
            source: 'confirm_international'
          }
        });
      case pathname.startsWith('/next/shipping'):
        return Lab.quoteZip(state, action);
      default:
        return null;
    }
  }
};

export default PageViewEvents;
